import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    tableLoading: false,
    viewContainerLoading: false,
    showViewContainer: false,
    searchQuery: "",
    currentPage: 1,
    perPage: 5,
    currentApprovalPage: 1,
    perPageApproval: 5,
    essleaveTotal: null,
    totalLeaveApprover: null,
    employees: [],
    leavesData: [],
    currentLeave: {},
    filterValue: "",
    filterDate: "",
    filterLeaveTypes: "",
    employeeLeave: [],
    approvals: [],
    currentApproval: {},
    leaveTypes: [],
  },
  actions,
  mutations,
};
